exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PartnersListLogo\\.module__partners1Logo___318H4 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  margin: auto 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"partners1Logo": "PartnersListLogo.module__partners1Logo___318H4"
};